module.exports = __webpack_public_path__ + "static/24-e536a3a191e937209f2e1993a8de5f34.jpg";